import { render, staticRenderFns } from "./tenants.vue?vue&type=template&id=df652996&scoped=true&"
import script from "./tenants.vue?vue&type=script&lang=js&"
export * from "./tenants.vue?vue&type=script&lang=js&"
import style0 from "./tenants.vue?vue&type=style&index=0&id=df652996&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df652996",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df652996')) {
      api.createRecord('df652996', component.options)
    } else {
      api.reload('df652996', component.options)
    }
    module.hot.accept("./tenants.vue?vue&type=template&id=df652996&scoped=true&", function () {
      api.rerender('df652996', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ugsrc/components/tenants/tenants.vue"
export default component.exports